// @flow

export const CONNECTION_TYPE = {
    GOOD: 'good',
    NON_OPTIMAL: 'nonOptimal',
    NONE: 'none',
    POOR: 'poor'
};
